<template>
  <mds-layout-grid class="newsflash-section">
    <mds-row align-horizontal="center" class="newsflash-section-grid">
      <mds-col align-vertical="center" :cols="12" class="newsflash-section-grid-col">
        <div v-if="loading" class="newsflash-loader">
          <mds-loader/>
        </div>
        <div v-else-if="emailList.length > 0" class="newsflash-section-container">
          <div class="newsflash-section-container-list">
            <mds-row
              v-for="item in emailList"
              class="newsflash-section-item"
              align-horizontal="center"
              :key="item.id"
            >
              <mds-col :cols="12">
                <NewsFlashItem
                  class="newsflash-item"
                  :itemid="item.id"
                  :title="item.newsTitle"
                  :description="item.newsText"
                  :publishDate="item.publishDate"
                />
              </mds-col>
            </mds-row>
          </div>
          <mds-row class="newsflash-section-view-all-link">
            <mds-col :cols="12">
              <div class="newsflash-view-all-link">
                <mds-button 
                  variation="flat" 
                  class="view-all-table-link"  
                  target="_blank"
                  :href="`${analyticsURL}${newsflashLink}`"
                  @click="handleNewsflashClick"
                >
                  View More Newsflash > 
                </mds-button>
              </div>
            </mds-col>
          </mds-row>
        </div>
        <div v-else class="newsflash-empty-state">
          <mds-empty-state title="No Records Found" message=""/>
        </div>
      </mds-col>
    </mds-row>
  </mds-layout-grid>
</template>

<script>
import NewsFlashItem from '@/components/NewsFlash/NewsFlashItem.vue';
import { getNewsFlashListByCount } from '@/services/newsflashServices';
import { links } from '@/data/constants.json';
import trackEvent from '@/utils/googleAnalytics';
import { events } from "@/config/events";

export default {
  name: 'NewsFlashHomeList',
  components: {
    NewsFlashItem,
  },
  created() {
    this.getNewsFlashList();
  },
  data() {
    return {
      emailList: [],
      noOfItemstoDisplay: 3,
      loading: false,
      analyticsURL: process.env.VUE_APP_ANALYTICS_BASE_URL,
      newsflashLink: links?.newsflashLink,
    };
  },
  methods: {
    handleNewsflashClick() {
      trackEvent(
        events.event.VIEW_NEWSFLASH, 
        events.category.VIEW_NEWSFLASH, 
        events.action.CLICK, 
        events.label.VIEW_NEWSFLASH, 
        `${this.analyticsURL}${this.newsflashLink}`
      );
    },
    getNewsFlashList() {
      this.loading = true;
      getNewsFlashListByCount(this.noOfItemstoDisplay).then(async (resp) => {
        this.emailList = resp;
      }).finally(() => {
        this.loading = false;
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.newsflash-section {
  &-container {
    display: flex;
    flex-direction: column;
    height: 100%;
    &-list {
      display: flex;
      flex-direction: column;
      height: 100%;
      flex: 1;
    }
  }
  &-item {
    flex: 1;
  }
}
.newsflash-section-grid, .newsflash-section-grid-col {
  height: 100%;
}
.newsflash-item {
  height: 100%;
  border-bottom: $mds-border-separator-on-light;
}

.newsflash-section-view-all-link {
  height: 50px;
}
img {
  display: block;
  height: auto;
  max-width: 100%;
  margin: 0 auto;
}

.newsflash-section {
  border-radius: $mds-border-radius-panel;
  border: $mds-border-separator-on-light;
  height: 586px;
  overflow: hidden;
  margin-bottom: $mds-space-4-x;
}

.newsflash-view-all-link {
  text-align: center;
  background-color: $mds-background-color-light-gray;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-all-table-link {
  @include mds-link($in-table: true);
  @include mds-body-text-m($bold: true);
  color: #006FBA !important;
}
.newsflash-loader, .newsflash-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
}
</style>
